export default __webpack_public_path__ + "static/exp3-9cf0b798bbfe4f40aa45040a5caca382.png";